<div class="h-100" [class.scrollbox-autohover]="!minimized">
	<div class="h-100 scrollbox-content-autohover">
		<div class="accordion h-100">
			<div class="me-0 me-3 h-100">
				@if (!minimized) {
					<div class="ps-3 ps-xl-5 h-100">
						<div class="h-100 d-flex flex-column justify-content-between">
							<div class="pb-4 pt-5">
								<!-- Display: List or Tree -->
								@if (showDisplayType()) {
									<div class="navigation-block pb-4">
										<div class="navigation-block-header">
											{{ 'catalog-view.hitdisplay' | translate }}
										</div>
										<div class="ps-1 mt-2">
											@for (mode of displayModes; track mode; let first = $first) {
												<div class="form-check" name="radioBasic">
													<input
														class="form-check-input"
														type="radio"
														name="displayRadioButtons"
														id="{{ mode.value }}"
														(click)="showresults(mode.value)"
														[checked]="catalogSearchResultModel.displayType === mode.value" />
													<label
														class="form-check-label w-100 position-relative cursor-pointer bg-gray-200-hover"
														for="{{ mode.value }}">
														<div class="d-flex">
															<div
																class="mask-settings bg-gray-700"
																[ngClass]="mode.image"
																style="min-width: 1.4rem; width: 1.4rem; height: 1.4rem"></div>
															<div
																class="ps-2 align-items-start"
																[ngClass]="mode.value === displayType.List ? 'two-lines' : 'one-line'">
																{{ mode.displayString | translate }}
																@if (mode.value === displayType.List) {
																	<span>
																		{{ 'catalog-view.sorted' | translate }}
																	</span>
																}
															</div>
														</div>
													</label>
												</div>
											}
										</div>
									</div>
								}
								<div class="pb-4">
									<!-- Search -->
									<app-catalog-searchbar
										[canNavigateToStartingPage]="canNavigateToStartingPage"
										[categoryGroups]="categoryGroups"
										[relatedCatalogs]="relatedCatalogs"
										[catalogKey]="catalogKey"
										(emptySearch)="emptySearch.emit()">
									</app-catalog-searchbar>
								</div>
								<!-- Tags -->
								<app-catalog-tagviewer
									[selectedTags]="selectedTags"
									[defaultTags]="defaultTags"
									[tags]="tags"
									(tagClicked)="tagClicked($event)"
									(resetFilter)="resetFilter()"
									[clickable]="true">
								</app-catalog-tagviewer>
							</div>
							<div>
								@if (hasNews) {
									<app-news-list #news [isMobile]="false" [catalogKey]="catalogKey" (openNews)="openNews.emit($event)">
									</app-news-list>
								}
								<app-more-catalogs
									[languageCatalogs]="languageCatalogs"
									[relatedCatalogs]="relatedCatalogs"
									[catalogSearchResultModel]="catalogSearchResultModel"
									[currentQueryParams]="currentQueryParams"
									[showAdditionalCatalogs]="showRelatedCatalogs"
									[showForeignLanguageCatalogs]="!showDisplayType() && showForeignLanguageCatalogs"></app-more-catalogs>
							</div>
						</div>
					</div>
				}
				@if (minimized) {
					<div class="h-100 d-flex flex-column justify-content-between">
						<div class="mt-5">
							<div class="mt-1">
								<div class="btn btn-outline-light m-2 p-2" (click)="minimize.emit()">
									<img
										src="/assets/material/search-24px-grey.svg"
										alt="{{ 'global.search' | translate }}"
										loading="lazy"
										width="24px"
										height="24px" />
								</div>
							</div>
							<div>
								<div class="btn btn-outline-light m-2 p-2" (click)="minimize.emit()">
									<img
										src="/assets/material/filter.svg"
										alt="{{ 'global.filter' | translate }}"
										loading="lazy"
										width="24px"
										height="24px" />
								</div>
							</div>
						</div>
						<div class="mb-5">
							@if (hasNews && hasSomeNews) {
								<div>
									<div class="btn btn-outline-light m-2 p-2" (click)="minimize.emit()">
										<img src="/assets/orca/catalogNews/news.svg" alt="News" loading="lazy" width="24px" height="24px" />
									</div>
								</div>
							}
							@if (!showDisplayType() && showForeignLanguageCatalogs && languageCatalogs?.length) {
								<div>
									<div class="btn btn-outline-light m-2 p-2" (click)="minimize.emit()">
										<img
											src="/assets/orca/searchFilter/world.svg"
											alt="{{ 'global.foreignLanguageCatalogs' | translate }}"
											loading="lazy"
											width="24px"
											height="24px" />
									</div>
								</div>
							}
							@if (showRelatedCatalogs && relatedCatalogs?.length) {
								<div>
									<div class="btn btn-outline-light m-2 p-2" (click)="minimize.emit()">
										<img
											src="/assets/orca/searchFilter/catalogs.svg"
											alt="{{ 'global.catalogs' | translate }}"
											loading="lazy"
											width="24px"
											height="24px" />
									</div>
								</div>
							}
						</div>
					</div>
				}
			</div>
		</div>
	</div>
</div>
